/* eslint-disable eqeqeq */
import React, { useState } from "react";
import { connect } from "react-redux";
import { currentLocationInfo } from "../../home/redux/actions";
import {  InputGroup, Form, ListGroup, ListGroupItem } from "react-bootstrap";
import { GapLocationList, geocodeAddress } from "../util/getRequest";
import { maintainAirportlist } from "../../header/redux/actions";
import { reverseGeocode } from "./../util/getRequest";

function CapAutocompletePlace (props) {

  const [locationList, SetLocationList] = useState([])
  const [ShowList, SetShowList] = useState(false);
  const [cursor, setCursor] = useState(0);

  const locationValueChange =async (address) => {
    props?.setAddress(address);
    const Responce = await GapLocationList(address, props?.searchOptions?.country);
    if(Responce?.status === "OK"){
      if(!ShowList)
      SetShowList(true);
      SetLocationList(Responce?.predictions);
    }
  };

  const OnSelectLocationHandler =async (e, index) =>{
    e.preventDefault();
    const SelectList = locationList?.filter((item, index1)=>index === index1);
    if(SelectList?.length >0){
      getGeoCode(SelectList[0]?.description)
    }else{
      getGeoCode(props?.address)
    }
    SetShowList(false);
    SetLocationList([]);
  }

  const getGeoCode = async (address) =>{
    const responce = await geocodeAddress(address);
    if(responce?.status === "OK" && responce?.results){
        const place  = responce?.results[0];
        const Lat = place?.geometry?.location?.lat;
        const lng = place?.geometry?.location?.lng;
        const ZipCode  = await reverseGeocode({ latitude:Lat, longitude:lng });
        props?.SetLocation({place, address:address, Lat, lng, ZipCode });
        ResetState()
    }
  }

  const GotoMain = (value) => {
    const elses = document.getElementById('innerDivscorll'+cursor);
    document.getElementById('menuScroll').scrollTo({top: elses.offsetTop+ value, behavior: 'smooth' })
  }

  const handleKeyDown = (e) =>{
      if(!props?.showairports){
          if(e.key === 'Enter'){
            OnSelectLocationHandler(e, cursor)
          }else if (e.keyCode === 38 && cursor > 0) {
            GotoMain(-90)
            setCursor(cursor - 1)
          } else if (e.keyCode === 40 && cursor < locationList.length - 1) {
            GotoMain(+10)
            setCursor(cursor + 1)
          }
      }else{
          if(e.key === 'Enter'){
            SelectFormPickup(e, props?.airport_list[cursor])
          }else if (e.keyCode === 38 && cursor > 0) {
            GotoMain(-90)
            setCursor(cursor - 1);
          } else if (e.keyCode === 40 && cursor < props?.airport_list.length - 1) {
            GotoMain(+10)
            setCursor(cursor + 1);
          }
      }
  }
  const SelectFormPickup = (e, item) =>{
    props?.selectPickuplocationairport(e, item);
    ResetState();
  }
  
  const ResetState = () =>{
    SetShowList(false);
    setCursor(0)
    SetLocationList([]);
  }

  return (
    <React.Fragment>
      <div className={`${props?.className} position-relative Location_dropdown transition`}>
          <InputGroup onClick={()=>SetShowList(true)} htmlFor={"Location_Search3"} >
            <InputGroup.Text>
                <img src={props?.formTaxt} alt="location"></img>
            </InputGroup.Text>
            <Form.Control
              placeholder={props?.placaddress? props?.placaddress: props.currentLocation.selectedLocation}
              value={props?.address}
              onChange={(e)=>locationValueChange(e.target.value)}
              id={"Location_Search3"}
              onKeyDown={ handleKeyDown }
              onClick={(e)=>{
                    SetShowList(true)
                  props?.onClick(e)
              }}
            />
          </InputGroup>
          {ShowList === true && 
            <React.Fragment>
              <ListGroup id="menuScroll">
                    {!props?.showairports ? 
                    <React.Fragment>
                      {locationList?.map((item, index)=>(
                          <ListGroupItem id={"innerDivscorll"+index} onMouseEnter={() => setCursor(index)} key={index?.toString()} onClick={(e)=>OnSelectLocationHandler(e, index)} className={cursor === index ? 'actions' : null} >
                              {item?.description}
                          </ListGroupItem>
                      ))}
                    </React.Fragment>
                    :<React.Fragment>
                        {props?.airport_list?.map((item, index) => (
                          <ListGroupItem id={"innerDivscorll"+index} onMouseEnter={() => setCursor(index)}  key={index?.toString()} onClick={(e)=>SelectFormPickup(e, item)} className={cursor === index ? 'actions' : null} >
                              {item.name}
                          </ListGroupItem>
                        ))}
                      </React.Fragment>
                    }
              </ListGroup>
              <div onClick={()=>ResetState()} className="background_click" />
            </React.Fragment>
            }
      </div>
    </React.Fragment>
  )
}
const mapStateToProps = (state) => ({
    currentLocation: state?.home?.currentLocation,
});
export default connect(mapStateToProps,{currentLocationInfo,maintainAirportlist})(CapAutocompletePlace);